import React from 'react';

import DrawerComponent from '@atlaskit/drawer';
import ProductStoreComponent from '@atlassiansox/product-store-react';
import CrossFlowIntegration from '@atlassiansox/cross-flow-react';

import { type IntegrationViewProps } from './types';
import { IntegrationView } from './view';

export default (props: IntegrationViewProps) => {
	return (
		<IntegrationView
			{...props}
			// @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
			DrawerComponent={DrawerComponent}
			ProductStoreComponent={ProductStoreComponent}
			CrossFlowComponent={CrossFlowIntegration}
		/>
	);
};
